import type { QbConnectionType } from '../models/clientsListTypes';

// Same labels as the Matters list, so the two pages read the same.
export const QB_CONNECTION_OPTIONS: { title: string; value: QbConnectionType }[] = [
  { title: 'QuickBooks Connection: Any', value: 'any' },
  { title: 'QuickBooks Connection: Good', value: 'good' },
  { title: 'QuickBooks Connection: Bad', value: 'bad' },
  { title: 'QuickBooks Connection: Not connected', value: 'none' },
];

export const QB_STATUS_TOOLTIP =
  'A green icon in this column shows that client is connected to QuickBooks and invoices can be generated.';
